import * as Sentry from '@sentry/vue'

export type CaptureErrorContext = Parameters<typeof Sentry.captureException>[1]

export function captureError(error: Error, context?: CaptureErrorContext) {
  Sentry.captureException(error, context)
}
